<template>
  <div>
    <v-card class="project-card">
      <div class="project-card__header">
        <v-card-text>
          <h1 v-if="title" class="project-card__title">
            {{title}}
          </h1>
          <v-tooltip
            max-width="320"
            color="#f5f5f5"
            top
            v-if="!loading"
            >
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <v-icon class="project-card__icon">mdi-information-outline</v-icon>
              </div>
            </template>
            <div class="project-card__tooltip">
              <slot name="tooltip">Lorem ipsum sit dolor...</slot>
            </div>
          </v-tooltip>
        </v-card-text>
        <Loader v-if="loading"
                :height="30"
                :width="30"
                ></Loader>
        <v-card-actions v-if="false && !loading">
          <TabCardMenu></TabCardMenu>
        </v-card-actions>
      </div>
      <div class="project-card__subheader" v-if="subtitle">
        <span class="text-lighten-1">{{subtitle}}</span>
      </div>
      <v-card-text v-if="errorMessage">
        <p class="error-message">{{errorMessage}}</p>
      </v-card-text>
      <slot v-if="!loading"> </slot>
    </v-card>
    <v-card-text v-if="hint" class="project-card__footer">
      <v-img class="footer__icon" :src="require('@/assets/img/logo_nameless--white.svg')"></v-img>
      <p class="footer__text">
        <slot name="hint">Here is a sentence explaining how to read the graph.</slot>
      </p>
    </v-card-text>
  </div>
</template>

<script>
    import TabCardMenu from "./Project/TabCardMenu";
    import Loader from "../Loader";

    export default {
        name: "ProjectCard",
        components: {Loader, TabCardMenu},
        props: {'title': String,
                'subtitle': String,
                'hint': Boolean,
                'loading': Boolean,
                'errorMessage': String}
    }
</script>
